export default __webpack_public_path__ + "static/pregnancy-b0c22b3f9c857eff2528d78f359fbc14.jpg";